import React, { useState, useEffect } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  LogoutOutlined,
  MedicineBoxOutlined,
  ClusterOutlined,
  TabletOutlined,
  UsergroupAddOutlined,
  FileDoneOutlined,
  MoneyCollectOutlined,
  PlusCircleOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Layout, Menu, theme, message, Modal } from "antd";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import SummaryContainer from "../summaryPage/SummaryContainer";
import AppointmentContainer from "../appointment/AppointmentContainer";
import PatientsContainer from "../patientsComponents/PatientsContainer";
import images from "../common/images/images";
import { useAuth } from "../context/AuthContext";
import * as helper from "../common/helper/helper";
import VideoCallComponent from "../summaryPage/VideoCallComponent";
import DoctorsContainer from "../doctorComponents/DoctorContainer";
import DevicesContainer from "../deviceComponents/DeviceContainer";
import TabletsContainer from "../tabletComponents/TabletComponents";
import KiosksContainer from "../kiosksComponent/KiosksContainer";
import PastAppointmentContainer from "../pastAppointment/PastAppointmentContainer";
import TransactionContainer from "../transactionComponents/TransactionContainer";
import EditDoctorProfile from "./EditDoctorProfile";
import PrescriptionContainer from "../prescription/PrescriptionContainer";
import MedicineContainer from "../medicineComponent/MedicineContainer";
import NotFound from "../NotFound";
import { API_URL } from "../../config";

const { Header, Sider, Content } = Layout;

const SidebarComponent = ({ handleNotFound }) => {
  const apiBaseUrl = API_URL;
  const [collapsed, setCollapsed] = useState(false);
  const [userType, setUserType] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [doctorDetails, setDoctorDetails] = useState(null);
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const [isOnVideoCall, setIsOnVideoCall] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [loading, setLoading] = useState(true);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const navigate = useNavigate();
  const location = useLocation();
  const loginRole = useAuth();

  useEffect(() => {
    const matchedRoutes = [
      "/video-call",
      "/appointments",
      "/patients",
      "/doctors",
      "/devices",
      "/tablets",
      "/kiosks",
      "/pastAppointment",
      "/transaction",
      "/medicine",
      "/prescription",
      "/",
    ];

    if (!matchedRoutes.includes(location.pathname)) {
      handleNotFound();
    }
  }, [location, handleNotFound]);

  useEffect(() => {
    const storedUserData = loginRole?.loginDoctorDetails?.type;

    setLoading(false);
    setUserType(storedUserData);
  }, []);

  useEffect(() => {
    const doctorId = sessionStorage.getItem("ID");
    if (doctorId) {
      setDoctorDetails(loginRole?.loginDoctorDetails);
    } else {
      console.error("Doctor ID not found in sessionStorage.");
    }
  }, []);

  useEffect(() => {
    if (doctorDetails) {
      fetch(
        `${apiBaseUrl}/user/download-profile-picture/${doctorDetails.firebase_id}`,
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          setProfilePictureUrl(data.url);
        })
        .catch((error) => {
          console.error("Error fetching profile picture:", error);
        });
    }
  }, [doctorDetails]);

  useEffect(() => {
    if (location.pathname === "/video-call") {
      setIsOnVideoCall(true);
    } else {
      setIsOnVideoCall(false);
    }
  }, [location.pathname]);

  const handleNavigation = (path) => {
    if (isOnVideoCall) {
      setIsConfirmModalVisible(true);
      message.error(
        "You are currently in a video call. Please end the call before navigating away.",
      );
      setPendingNavigation(path);
    } else {
      navigate(path);
    }
  };

  if (loading) {
    return <div></div>;
  }

  const handleConfirmNavigation = () => {
    setIsConfirmModalVisible(false);
    navigate(pendingNavigation);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleProfileUpdate = (updatedDetails) => {
    setDoctorDetails(updatedDetails);
  };
  return (
    <Layout style={{ height: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ backgroundColor: "#EACE88" }}
      >
        <div
          className="logo"
          style={{ padding: "16px", textAlign: "center", marginBottom: "15%" }}
        >
          <img
            src={collapsed ? images.sidebarSmallLogo : images.sidebarLogo}
            alt="Logo"
            style={{ width: "100%" }}
          />
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["/appointments"]}
          selectedKeys={[location.pathname]}
          style={{ backgroundColor: "#EACE88" }}
        >
          {userType === "doctor" && (
            <Menu.Item
              key="/appointments"
              icon={<VideoCameraOutlined />}
              style={{
                color:
                  location.pathname === "/appointments" ? "#FFFFFF" : "#000000",
              }}
              onClick={() => handleNavigation("/appointments")}
            >
              Appointments
            </Menu.Item>
          )}
          {userType === "medicine_admin" && (
            <Menu.Item
              key="/prescription"
              icon={<SnippetsOutlined />}
              style={{
                color:
                  location.pathname === "/prescription" ? "#FFFFFF" : "#000000",
              }}
              onClick={() => handleNavigation("/prescription")}
            >
              Prescription
            </Menu.Item>
          )}
          {userType === "admin" && (
            <>
              <Menu.Item
                key="/patients"
                icon={<UserOutlined />}
                style={{
                  color:
                    location.pathname === "/patients" ? "#FFFFFF" : "#000000",
                }}
                onClick={() => handleNavigation("/patients")}
              >
                Patients
              </Menu.Item>
              <Menu.Item
                key="/doctors"
                icon={<MedicineBoxOutlined />}
                style={{
                  color:
                    location.pathname === "/doctors" ? "#FFFFFF" : "#000000",
                }}
                onClick={() => handleNavigation("/doctors")}
              >
                Doctors
              </Menu.Item>
              <Menu.Item
                key="/devices"
                icon={<ClusterOutlined />}
                style={{
                  color:
                    location.pathname === "/devices" ? "#FFFFFF" : "#000000",
                }}
                onClick={() => handleNavigation("/devices")}
              >
                Devices
              </Menu.Item>
              <Menu.Item
                key="/tablets"
                icon={<TabletOutlined />}
                style={{
                  color:
                    location.pathname === "/tablets" ? "#FFFFFF" : "#000000",
                }}
                onClick={() => handleNavigation("/tablets")}
              >
                Tablets
              </Menu.Item>
              <Menu.Item
                key="/kiosks"
                icon={<UsergroupAddOutlined />}
                style={{
                  color:
                    location.pathname === "/kiosks" ? "#FFFFFF" : "#000000",
                }}
                onClick={() => handleNavigation("/kiosks")}
              >
                Kiosks
              </Menu.Item>
              <Menu.Item
                key="/pastAppointment"
                icon={<FileDoneOutlined />}
                style={{
                  color:
                    location.pathname === "/pastAppointment"
                      ? "#FFFFFF"
                      : "#000000",
                }}
                onClick={() => handleNavigation("/pastAppointment")}
              >
                Past Appointments
              </Menu.Item>
              <Menu.Item
                key="/transaction"
                icon={<MoneyCollectOutlined />}
                style={{
                  color:
                    location.pathname === "/transaction"
                      ? "#FFFFFF"
                      : "#000000",
                }}
                onClick={() => handleNavigation("/transaction")}
              >
                Transaction
              </Menu.Item>
              <Menu.Item
                key="/medicine"
                icon={<PlusCircleOutlined />}
                style={{
                  color:
                    location.pathname === "/medicine" ? "#FFFFFF" : "#000000",
                }}
                onClick={() => handleNavigation("/medicine")}
              >
                Medicine
              </Menu.Item>
            </>
          )}
        </Menu>
        <div
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            padding: "16px",
          }}
        >
          <h3>Profile</h3>
          <div className="patient-info" onClick={showModal}>
            <Avatar
              size={50}
              icon={!profilePictureUrl && <UserOutlined />}
              src={profilePictureUrl || null}
            >
              {!profilePictureUrl &&
                helper.getInitials(doctorDetails?.first_name)}
            </Avatar>
            {!collapsed && (
              <div className="patient-details" style={{ cursor: "pointer" }}>
                <p>{`${doctorDetails?.first_name} ${doctorDetails?.last_name}`}</p>
                <h6
                  className="sidebarProfile"
                  style={{ textTransform: "capitalize" }}
                >{`${userType}`}</h6>
              </div>
            )}
          </div>
          <Button
            type="primary"
            icon={<LogoutOutlined />}
            style={{ width: "100%" }}
            onClick={handleLogout}
          >
            {!collapsed ? "Logout" : null}
          </Button>
        </div>
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 44,
            }}
          />
        </Header>
        <Content
          style={{
            padding: 14,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            overflowY: "auto",
            height: "calc(100vh - 64px)",
          }}
        >
          <Routes>
            {userType === "doctor" && (
              <>
                <Route path="/video-call" element={<VideoCallComponent />} />
                <Route path="/" element={<AppointmentContainer />} />
                <Route
                  path="/appointments"
                  element={<AppointmentContainer />}
                />
              </>
            )}
            {userType === "admin" && (
              <>
                <Route path="/" element={<PatientsContainer />} />
                <Route path="/patients" element={<PatientsContainer />} />
                <Route path="/doctors" element={<DoctorsContainer />} />
                <Route path="/devices" element={<DevicesContainer />} />
                <Route path="/tablets" element={<TabletsContainer />} />
                <Route path="/kiosks" element={<KiosksContainer />} />
                <Route
                  path="/pastAppointment"
                  element={<PastAppointmentContainer />}
                />
                <Route path="/transaction" element={<TransactionContainer />} />
                <Route path="/medicine" element={<MedicineContainer />} />
              </>
            )}
            {userType === "medicine_admin" && (
              <>
                <Route path="/" element={<PrescriptionContainer />} />
                <Route
                  path="/prescription"
                  element={<PrescriptionContainer />}
                />
              </>
            )}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Content>
      </Layout>

      <Modal
        title="Edit Doctor Profile"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={1000}
        style={{ top: 20 }}
      >
        {doctorDetails && (
          <EditDoctorProfile
            doctorDetails={doctorDetails}
            onClose={handleCancel}
            onProfileUpdate={handleProfileUpdate}
          />
        )}
      </Modal>

      {/* <Modal
        title="Confirm Navigation"
        visible={isConfirmModalVisible}
        onOk={handleConfirmNavigation}
        onCancel={() => setIsConfirmModalVisible(false)}
        okText="Yes"
        cancelText="No"
      >
        <p>
          You are currently in a video call. Do you want to end the call and
          navigate away?
        </p>
      </Modal> */}
    </Layout>
  );
};

export default SidebarComponent;
